import { MultiSelectModule } from 'primeng/multiselect';
import { MojoQueryBuilderComponent } from './query-builder.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxAngularQueryBuilderModule  } from 'ngx-angular-query-builder';
import { FormsModule } from '@angular/forms';
import { MojoControlsModule } from '../mojo-controls/mojo-controls.module';

@NgModule({
  declarations: [
    MojoQueryBuilderComponent
  ],
  exports: [
    MojoQueryBuilderComponent
    ],
  imports: [
    CommonModule,
    NgxAngularQueryBuilderModule ,
    FormsModule,
    MultiSelectModule,
    MojoControlsModule
    ],
})
export class MojoNgxAngularQueryBuilderModule  { }
